<template>
  <div>
<b-form-group
      label-cols="4" label-cols-lg="2"
      label="Edat:" label-size="sm"
    >
    <b-input-group>
      <b-form-group class="group-variable-edat mb-0 mr-2"
        label-cols-sm="0"
        label=""
        label-for="input-9" 
        description="" 
      >      
      <b-input-group size="sm" prepend="Des de" append="anys ">
        <b-form-input size="sm" id="input-9" class="var-edat" type="number" v-model="limitInferior" @input="onUpdateLimitInferior"></b-form-input>
      </b-input-group>              
      </b-form-group>      

      <b-form-group class="group-variable-edat mb-0 mr-2"
        label-cols-sm="0"
        label=""
        label-for="input-10"
        description="" 
      >
      <b-input-group size="sm" prepend="fins a" append='anys'>      
        <b-form-input size="sm" id="input-10" class="var-edat" type="number" v-model="limitSuperior"  @input="onUpdateLimitSuperior"></b-form-input>
      </b-input-group>        
      </b-form-group>      
    </b-input-group>

    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "VariableEdat",
  props: {
    initialValue:{      
      required: true
    }
  },   
  data() {
    return {
      codiVariable: 'edat',
      limitInferior: null,
      limitSuperior: null
    };
  },
  computed:{
    returnValue(){
      let r = {codi: this.codiVariable, valor:{}}
      if(this.limitInferior!=null && this.limitInferior!=''){
        r.valor.limitInferior = this.limitInferior
      }
      if(this.limitSuperior!=null && this.limitSuperior!=''){
        r.valor.limitSuperior = this.limitSuperior
      }
      return r;
    }
  },   
  methods: {    
    onUpdateLimitSuperior(newValue){
      console.log(newValue)
      if(this.returnValue.valor.limitInferior || this.returnValue.valor.limitSuperior){
        this.$emit('variable-editada', this.returnValue)         
      }else{
        this.$emit('variable-eliminada', this.codiVariable)
      }      
    },
    onUpdateLimitInferior(newValue){
      console.log(newValue)
      if(this.returnValue.valor.limitInferior || this.returnValue.valor.limitSuperior){
        this.$emit('variable-editada', this.returnValue)         
      }else{
        this.$emit('variable-eliminada', "edat")
      }      
    }    
  },
  mounted() {
    console.log("mounted")
    console.log(this.initialValue)
    if(this.initialValue!=null){
      this.limitInferior = this.initialValue.valor.limitInferior;
      this.limitSuperior = this.initialValue.valor.limitSuperior;
    }    
  }
};
</script>

<style>
.var-edat{
  max-width: 60px
}
</style>